import { render } from "./ManageStaffModal.vue?vue&type=template&id=6f2b9de2"
import script from "./ManageStaffModal.vue?vue&type=script&lang=js"
export * from "./ManageStaffModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__